"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultConfig = exports.Picsum = void 0;
const axios_1 = __importDefault(require("axios"));
const BASE_URL = 'https://picsum.photos';
const defaultConfig = {
    blur: 0,
    cache: true,
    grayscale: false,
    height: 200,
    id: 0,
    jpg: false,
    width: 200,
};
exports.defaultConfig = defaultConfig;
const Picsum = {
    url(override = {}) {
        let url = BASE_URL;
        const config = {
            ...defaultConfig,
            ...override,
        };
        if (config.id) {
            url += `/id/${config.id}`;
        }
        if (config.height) {
            url += `/${config.height}`;
        }
        if (config.width) {
            url += `/${config.width}`;
        }
        if (config.jpg) {
            url += '.jpg';
        }
        const params = {};
        if (config.grayscale) {
            params.grayscale = config.grayscale;
        }
        if (config.blur) {
            params.blur = config.blur;
        }
        if (config.cache) {
            params.random = Math.floor(Math.random() * 10000);
        }
        const paramString = Object.keys(params).map(key => key + '=' + params[key]).join('&');
        if (paramString) {
            url += `?${paramString}`;
        }
        return url;
    },
    async random() {
        const page = Math.floor(Math.random() * 990);
        const { data } = await axios_1.default.get(`https://picsum.photos/v2/list?page=${page}&limit=1`);
        data[0].download_url += '.jpg';
        return data[0];
    },
};
exports.Picsum = Picsum;
//# sourceMappingURL=index.js.map